// extracted by mini-css-extract-plugin
export default {"card":"_2bdg__YEKbTTluG6CQsl9S","cardActive":"_300_Z3NtDnR4_VyGzMe2SJ"};